<p-dialog
    [contentStyle]="{ overflow: 'auto', 'max-width': '75vw', 'height': '80vh'}"
    [styleClass]="'sm:col-12 md:col-12 lg:col-7 xl:col-6'"
    [(visible)]="visible"
    [modal]="true"
    [closable]="true"
    (onHide)="close('move')"
>
    <ng-template pTemplate="header">
        <span class="p-dialog-title">
            {{'Compo_Bsk' | translate}}
        </span>
    </ng-template>
    @if (displayThumbnails === true) {
        <div class="w-full p-2 flex justify-content-between flex-wrap">
            <div class="flex">
                <p-fileUpload
                    mode="basic" 
                    name="file"
                    (onSelect)="onSelect($event)"
                    [multiple]="false"
                    [showUploadButton]="false"
                    [showCancelButton]="false"
                    chooseLabel="{{'CompoAddFile' | translate}}"
                >
                </p-fileUpload>
            </div>
            <div class="flex">
                <div class="ml-2">
                    <p-button (onClick)="onClickButtonValid($event)" label="{{'Valid' | translate}}"></p-button>
                </div>
            </div>
        </div>
    }
    <div class="innerpdf full-100" style="position: relative">
        @if ( pathPdf  !== '') {
            @if (displayThumbnails === false) {
                <div>
                    <p-progressBar
                      [showValue]="true"
                      [value]="prgBarr"
                      [style]="{ height: '10px'}"
                    ></p-progressBar>
                    <div class="p-bar">{{ prcProgress }} %</div>
                </div>
                <ngx-extended-pdf-viewer
                    #pdfviewerpdf
                    class="hidden"
                    [(src)]="pathPdf"
                    [sidebarVisible]="true"
                    [activeSidebarView]="1"
                    [(page)]="currentPage"
                    [enableDragAndDrop]="false"
                    (pagesLoaded)="onPdfLoadComplete($event)"
                    (pdfLoadingFailed)="onEvent('pdfLoadingFailed', $event)"
                >
                </ngx-extended-pdf-viewer>
            }
            @if (displayThumbnails === true) {
                <app-image-gallery [imageItems]="parentImageItems" [contextMenu]="menuImage" (imageItemsChange)="onimageItemsChange($event)"></app-image-gallery>
            }
            @if (!parentImageItems || parentImageItems.length === 0) {
                <div>{{'CompoWait' | translate}}</div>
            }
        }
    </div>
</p-dialog>